import { Injectable } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { FormFieldBase } from '@emm/shared/interfaces/form-field-base/form-field-base';
import { BehaviorSubject } from 'rxjs';
import {UserService} from '@emm/core/services/user.service';

@Injectable()
export class DynamicFormFieldService {
    isReadOnly = this.userService.hasLoginRole();
    isSuperAdmin = this.userService.hasSuperAdminRole();
    isAdmin = this.userService.hasAdminRole();
    isAuthor = this.userService.hasAuthorRole();
    canEdit = this.isSuperAdmin || this.isAdmin || this.isAuthor;
    formGroup: FormGroup;
    formFields;
    model = new BehaviorSubject<FormFieldBase<string>[]>(null);
    constructor(private userService: UserService) { }

    toMenuFormGroup(
        formFields: FormFieldBase<string>[],
        isReadOnly?: boolean,
        featureScope?: string,
        existingUpdates?: [],
    ): FormGroup {
        // console.log(formFields);
        const group: any = {};
        this.formFields = formFields;
        // isReadOnly is only sent for form fields that render in the Menu section
        if (isReadOnly === true || isReadOnly === false) {
            formFields.forEach(formField => {
                const isDropdown = (formField.type === 'SELECT' || formField.type === 'MULTI_SELECT' ||
                    formField.type === 'BOOL');
                if (featureScope === 'Viewer' && isDropdown){
                    group[formField.jsonProperty] = formField.required ? new FormControl({value: formField.value,
                            disabled: false}, Validators.required) :
                        new FormControl({ value: formField.value, disabled: false});
                }
                else {
                    group[formField.jsonProperty] = formField.required ? new FormControl({
                            value: formField.value,
                            disabled: isReadOnly || !this.canEdit
                        }, Validators.required) :
                        new FormControl({value: formField.value, disabled: isReadOnly || !this.canEdit});
                }
                }
            );
            this.model.next(this.formFields);
            this.formGroup = new FormGroup(group);
        }
        if (existingUpdates) {
            // console.log(existingUpdates);
            Object.keys(this.formGroup.controls).forEach((key) => {
                if (existingUpdates[key]) {
                    const currentControl = this.formGroup.controls[key];
                    currentControl.setValue(existingUpdates[key]);
                    currentControl.markAsDirty();
                }
            });
            return this.formGroup;
        } else {
            return this.formGroup;
        }
    }

    toManagementFormGroup(
        formFields: FormFieldBase<string>[],
        existingUpdates?: [],
    ): FormGroup {
        // console.log(formFields);
        const group: any = {};
        this.formFields = formFields;
        formFields.forEach(formField => {
                group[formField.jsonProperty] = formField.metadata.required ? new FormControl({value: formField.values[0].value,
                        disabled: formField.metadata.readOnly || !this.canEdit}, Validators.required) :
                    new FormControl({ value: formField.values[0].value, disabled: formField.metadata.readOnly
                            || !this.canEdit});
            }
        );
        this.model.next(this.formFields);
        this.formGroup = new FormGroup(group);
        if (existingUpdates) {
            // console.log(existingUpdates);
            Object.keys(this.formGroup.controls).forEach((key) => {
                if (existingUpdates[key]) {
                    const currentControl = this.formGroup.controls[key];
                    currentControl.setValue(existingUpdates[key]);
                    currentControl.markAsDirty();
                }
            });
            return this.formGroup;
        } else {
            return this.formGroup;
        }
    }
}
